<button
  #originRef
  (click)="showPopover()"
  [class.bg-hover]="dropdownOpen"
  class="button relative"
  mat-icon-button
  type="button">
  <mat-icon color="primary" svgIcon="mat:notifications_active" style="color: white;"></mat-icon>
  <div
    *ngIf="hasNewNotifications"
    class="absolute top-0 right-0 h-2 w-2 rounded-full bg-red-500">
  </div>
</button>
